<div class="prepaid-checkout-summary">
  <div class="prepaid-checkout-summary__title">{{ summary.title }}</div>
  <div class="prepaid-checkout-summary__rows">
    <div class="prepaid-checkout-summary__row">
      <img
        src="assets/images/payment-summary/clipboard-list.svg"
        alt=""
        class="prepaid-checkout-summary__icon"
      />
      <span>Prepaid</span>
    </div>
    <div class="prepaid-checkout-summary__row" *ngIf="summary.validityLine">
      <img
        src="assets/images/payment-summary/calendar.svg"
        alt=""
        class="prepaid-checkout-summary__icon"
      />
      <span>{{ summary.validityLine }}</span>
    </div>
    <div class="prepaid-checkout-summary__row" *ngIf="summary.vehicleSummary">
      <img src="assets/images/payment-summary/car.svg" alt="" class="prepaid-checkout-summary__icon" />
      <span>{{ summary.vehicleSummary }}</span>
    </div>
  </div>
  <div class="prepaid-checkout-summary__price">
    <span class="prepaid-checkout-summary__amount">{{ summary.priceFormatted }}</span>
  </div>
</div>
